import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { registerWebUser } from '../api/APIService';
import Toast from './Toast';
import Loader from './Loader';

const Signup = () => {
  const [formData, setFormData] = useState({
    name: '',
    email: '',
    mobile: '',
    password: '',
    confirmPassword: '',
    acceptTerms: false
  });

  const [showModal, setShowModal] = useState(false);
  const [showPrivacyModal, setShowPrivacyModal] = useState(false);
  const [loading, setLoading] = useState(false);
  const [toast, setToast] = useState({ show: false, message: '', type: 'success' });
  const [errors, setErrors] = useState({});

  const navigate = useNavigate();

  const handleChange = (e) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value
    });
  };

  const validateForm = () => {
    const newErrors = {};

    const passwordRegex = /^[a-zA-Z0-9!@#$%^&*]{4,}$/;

    if (!formData.name.trim() || formData.name.length < 4) {
      newErrors.name = "Please provide valid full name.";
    }
    if (!formData.email.trim() || !/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(formData.email)) {
      newErrors.email = "Please provide valid email.";
    }
    if (!formData.password || !passwordRegex.test(formData.password.trim())) {
      newErrors.password = "Please provide valid password.";
    }
    if (formData.password !== formData.confirmPassword) newErrors.confirmPassword = "Password do not match";
    if (!/^\d{10}$/.test(formData.mobile)) newErrors.mobile = "Please provide valid 10 digit mobile number";

    if (!formData.acceptTerms) {
      newErrors.terms = "Please read and accept terms and condions.";
    }
    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };


  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!validateForm()) return;

    setLoading(true);
    try {
      await registerWebUser({
        fullName: formData.name,
        username: formData.email,
        email: formData.email,
        password: formData.password,
        mobileNumber: formData.mobile,
        roles: ["WEB_USER"]
      });
      setToast({ show: true, message: 'Signup successful! Support team will contact you for further verification.', type: 'success' });
      //setTimeout(() => navigate('/login'), 2000);
    } catch (error) {
      console.error('Signup failed:', error);
      setToast({ show: true, message: 'Signup failed. Please try again.', type: 'error' });
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="container mt-5">
      <div className="row justify-content-end">
        <div className="col-md-5">
          <div className="card">
            <div className="card-body">
              <h1 className="text-center mb-4">Sign Up</h1>
              <form onSubmit={handleSubmit}>
                <div className="mb-3">
                  {errors.name && <p className="error-text"><span>{errors.name}</span></p>}
                  <input
                    type="text"
                    name="name"
                    className="form-control"
                    placeholder="Full Name"
                    value={formData.name}
                    onChange={handleChange}
                  />
                </div>
                <div className="mb-3">
                  {errors.email && <p className="error-text"><span>{errors.email}</span></p>}
                  <input
                    name="email"
                    className="form-control"
                    placeholder="Email"
                    value={formData.email}
                    onChange={handleChange}

                  />
                </div>
                <div className="mb-3">
                  {errors.mobile && <p className="error-text"><span>{errors.mobile}</span></p>}
                  <input
                    type="number"
                    name="mobile"
                    className="form-control"
                    placeholder="Mobile Number"
                    value={formData.mobile}
                    onChange={handleChange}

                  />
                </div>
                <div className="mb-3">
                  {errors.password && <p className="error-text"><span>{errors.password}</span></p>}
                  <input
                    type="password"
                    name="password"
                    className="form-control"
                    placeholder="Password"
                    value={formData.password}
                    onChange={handleChange}

                  />
                </div>
                <div className="mb-3">
                  {errors.confirmPassword && <p className="error-text"><span>{errors.confirmPassword}</span></p>}
                  <input
                    type="password"
                    name="confirmPassword"
                    className="form-control"
                    placeholder="Confirm Password"
                    value={formData.confirmPassword}
                    onChange={handleChange}

                  />
                </div>
                <div className="mb-3 form-check">
                  {errors.terms && <p className="error-text"><span>{errors.terms}</span></p>}
                  <input
                    type="checkbox"
                    name="acceptTerms"
                    className="form-check-input"
                    id="acceptTerms"
                    checked={formData.acceptTerms}
                    onChange={handleChange}

                  />
                  <label className="form-check-label" htmlFor="acceptTerms">
                    I agree to the <button type="button" className="btn btn-link p-0" onClick={() => setShowPrivacyModal(true)}>Privacy Policy</button> and <button type="button" className="btn btn-link p-0" onClick={() => setShowModal(true)}>Terms & Conditions</button>
                  </label>
                </div>
                <button type="submit" className="btn btn-teal w-100" disabled={loading}>
                  {loading ? 'Signing up...' : 'Sign Up'}
                </button>
              </form>
            </div>
          </div>
        </div>
      </div>
      {showModal && (
        <div className="modal show d-block" tabIndex="-1">
          <div className="modal-dialog">
            <div className="modal-content">
              <div className="modal-header">
                <h5 className="modal-title">Terms and Conditions</h5>
                <button type="button" className="btn-close" onClick={() => setShowModal(false)}></button>
              </div>
              <div className="modal-body">
                <h6 style={{ fontWeight: "bold" }}>Introduction</h6>
                <p style={{ fontSize: "small" }}>
                  These Terms & Conditions ("Terms") govern your use of the vakralabs.com web portal, developed by Vakralabs Services, located in Punawale, Pimpri-Chinchwad, Pune – 411033.
                </p>
                <h6 style={{ fontWeight: "bold" }}>Acceptance of Terms</h6>
                <p style={{ fontSize: "small" }}>
                  By downloading, accessing, or using the vakralabs.com website, you agree to be bound by these Terms. If you do not agree, please do not use the website.
                </p>
                <h6 style={{ fontWeight: "bold" }}>User Obligations</h6>
                <ul style={{ fontSize: "small" }} >
                  <li>You agree to use the website only for lawful purposes and in a manner that does not violate any applicable laws or regulations.</li>
                  <li>You must provide accurate information during registration and update it as needed.</li>
                  <li>You are responsible for maintaining the confidentiality of your account credentials.</li>
                </ul>
                <h6 style={{ fontWeight: "bold" }} >Use of Information</h6>
                <p style={{ fontSize: "small" }}>
                  All data provided by users, information, is used only to offer better services. We do not share your data without consent, except where required by law.
                </p>
                <h6 style={{ fontWeight: "bold" }} >Disclaimer</h6>
                <p style={{ fontSize: "small" }}>
                  vakralabs.com website is not a government-affiliated site. Any government scheme information is provided for informational purposes only and includes proper source links to official government portals.
                </p>
                <h6 style={{ fontWeight: "bold" }} >Limitation of Liability</h6>
                <p style={{ fontSize: "small" }}>
                  Vakralabs Services shall not be liable for any direct, indirect, incidental, or consequential damages arising out of the use or inability to use the website.
                </p>
                <h6 style={{ fontWeight: "bold" }} >Modifications</h6>
                <p style={{ fontSize: "small" }}>
                  Vakralabs Services reserves the right to update or change these Terms at any time. Continued use of the website after changes are made will be deemed acceptance of those changes.
                </p>
                <h6 style={{ fontWeight: "bold" }} >Termination</h6>
                <p style={{ fontSize: "small" }}>
                  We reserve the right to terminate or suspend your account if we find any violation of these Terms or misuse of the website.
                </p>
                <h6 style={{ fontWeight: "bold" }} >Governing Law</h6>
                <p style={{ fontSize: "small" }}>
                  These Terms shall be governed by the laws of India. Any disputes shall be subject to the jurisdiction of courts in Pune, Maharashtra.
                </p>
                <h6 style={{ fontWeight: "bold" }}>Grievance Redressal</h6>
                <p style={{ fontSize: "small" }}>
                  For any complaints or queries regarding these Terms, please contact:<br />
                  <strong>Grievance Officer</strong><br />
                  Vakralabs Services<br />
                  C-902, Bhalchandra Akashvan <br />
                  Punawale, Pimpri-Chinchwad, Pune – 411033<br />
                  📧 support@vakralabs.com
                </p>
              </div>
              <div className="modal-footer">
                <button type="button" className="btn btn-secondary" onClick={() => setShowModal(false)}>Close</button>
              </div>
            </div>
          </div>
        </div>
      )}
      {showPrivacyModal && (
        <div className="modal show d-block" tabIndex="-1">
          <div className="modal-dialog">
            <div className="modal-content">
              <div className="modal-header">
                <h5 className="modal-title">Privacy Policy</h5>
                <button type="button" className="btn-close" onClick={() => setShowPrivacyModal(false)}></button>
              </div>
              <div className="modal-body">
                <h6 style={{ fontWeight: "bold" }} >Introduction</h6>
                <p style={{ fontSize: "small" }} >
                  vakralabs.com website is a product of Vakralabs Services, located at Punawale, Pimpri-Chinchwad, Pune, Maharashtra - 411033.
                  Please read these Privacy Policies carefully before using BG-Mitra App. The user must agree and accept all the terms before using the website.
                </p>

                <h6 style={{ fontWeight: "bold" }} >Information Collection</h6>
                <p style={{ fontSize: "small" }} >
                  We collect basic personal details like name, email, mobile number, etc., for registration and service enhancement.
                </p>

                <h6 style={{ fontWeight: "bold" }} >Data Security</h6>
                <p style={{ fontSize: "small" }} >
                  We implement reasonable security measures to safeguard your data. However, no system is fully secure and we cannot guarantee absolute protection.
                </p>

                <h6 style={{ fontWeight: "bold" }} >Cookies</h6>
                <p style={{ fontSize: "small" }} >
                  We may use cookies to improve your experience and understand user behavior. Cookies do not collect personal information unless you provide it.
                </p>

                <h6 style={{ fontWeight: "bold" }} >Government Scheme Disclaimer</h6>
                <p style={{ fontSize: "small" }}>
                  vakralabs.com website is not a government entity. All government scheme data is sourced from public websites and official news agencies. We do not represent any government body.
                </p>

                <h6 style={{ fontWeight: "bold" }} >Children's Privacy</h6>
                <p style={{ fontSize: "small" }}>
                  We do not knowingly collect information from children under 13. If we find such data, it will be deleted immediately.
                </p>

                <h6 style={{ fontWeight: "bold" }} >Changes to This Policy</h6>
                <p style={{ fontSize: "small" }}>
                  The policy may be updated periodically. We encourage users to check this page regularly for updates.
                </p>

                <h6 style={{ fontWeight: "bold" }} >Grievance Redressal</h6>
                <p style={{ fontSize: "small" }}>
                  For issues related to privacy or misuse of content, please contact:
                  <br />
                  <strong>Grievance Officer</strong><br />
                  Vakralabs Services<br />
                  C-902, Bhalchandra Akashvan<br />
                  Punawale, Pimpri-Chinchwad, Pune - 411033<br />
                  📧 support@vakralabs.com
                </p >

              </div>
              <div className="modal-footer">
                <button type="button" className="btn btn-secondary" onClick={() => setShowPrivacyModal(false)}>Close</button>
              </div>
            </div>
          </div>
        </div>
      )}
      <Toast
        show={toast.show}
        message={toast.message}
        type={toast.type}
        onClose={() => setToast({ ...toast, show: false })}
      />
      <Loader show={loading} />
    </div>
  );
};

export default Signup;